import { render, staticRenderFns } from "./outer-case.vue?vue&type=template&id=161b8b12&scoped=true"
import script from "./outer-case.vue?vue&type=script&lang=ts"
export * from "./outer-case.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161b8b12",
  null
  
)

export default component.exports